import styled from '@emotion/styled';
import { Typography } from '@mgmresorts/mgm-ui';

export const StyledBirthdayHint = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgHighContrast};
`;

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.semantic.SpaceComponentM}px;
`;
